import React from 'react';
import { GREEN } from '../const';

const SVG = ({ style = {}, color = GREEN, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} fill="none">
      <circle cx="50" cy="50" r="46" strokeWidth="8" />
      <polyline points="28,51 46,67 71,31" strokeWidth="10" />
    </g>
  </svg>
);

export default SVG;
